import React, {useEffect} from 'react';
import {MeetingTabs} from './components/MeetingTabs';
import {InvitationDataGrid} from './components/InvitationDataGrid';
import {InvitationReviewsInput} from '../../schema-types/globalTypes';
import {
  accountNameColumn,
  dateScheduledForColumn,
  ownerColumn,
  meetingHostColumn,
  locationColumn,
  clientsColumn,
  propositionTypeColumn,
  rtqStatusColumn,
  ecqStatusColumn,
} from './invitationColumns';
import {InvitationFilters} from './InvitationFilters';
import withAutoFormNew from '../../components/AutoForm/AutoFormNew';
import {InvitationFormSchema, InvitationPageProps} from './invitationFormProps';
import {useLocalStorage} from '../../hooks/useLocalStorage';
import {useAutoForm} from '../../components/AutoForm/useAutoForm';

const ScheduledInner: React.FC = () => {
  const [_, setLocalStorage] = useLocalStorage<
    InvitationFormSchema | Record<string, never>
  >('scheduled', {});
  const {values} = useAutoForm<InvitationFormSchema>();

  useEffect(() => {
    setLocalStorage(values);
  }, [values]);

  // DataGrid columns - using imported column definitions
  const columns = [
    accountNameColumn,
    clientsColumn,
    ownerColumn,
    meetingHostColumn,
    propositionTypeColumn,
    dateScheduledForColumn,
    locationColumn,
    rtqStatusColumn(true),
    ecqStatusColumn(true),
  ];

  return (
    <>
      <InvitationFilters includeATR includeECQ />
      <InvitationDataGrid
        inviteStatus={InvitationReviewsInput.SCHEDULED}
        staff={values?.staff}
        ecqStatus={values?.ecqStatus}
        atrStatus={values?.atrStatus}
        search={values?.search}
        columns={columns}
        entityName="scheduled meetings"
        noDataMessage="No scheduled meetings found"
      />
    </>
  );
};

const ScheduledWrapped = withAutoFormNew<InvitationFormSchema, InvitationPageProps>(
  ScheduledInner,
  undefined,
  {debugPosition: 'bottom'}
);

export const ScheduledPage: React.FC = () => {
  const [initialValue] = useLocalStorage<InvitationFormSchema>('scheduled', {
    staff: '',
    search: '',
    atrStatus: 'ALL',
    ecqStatus: 'ALL',
  });
  return (
    <>
      <MeetingTabs />
      <ScheduledWrapped initialValueOverrides={initialValue} formFields={[]} />
    </>
  );
};
